import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {DxTreeListComponent} from "devextreme-angular";
import {MassGenerateKITextsParameter} from "../../../Model/MassGenerateKITextsParameter";
import {ModelService} from "../../../Services/model.service";
import {TreeItem} from "../../../Model/Dto/TreeItem";
import {InvoiceService} from "../../../Services/invoice.service";
import {TeachingSetService} from "../../../Services/teachingSet.service";
import {TranslateService} from '@ngx-translate/core';
import {AiPrompt} from "app/Model/aiprompt";


@Component({
    selector: 'massGenerateKIText',
    templateUrl: './massGenerateKIText.component.html',
    standalone: false
})
export class MassGenerateKITextComponent implements OnInit {
  @Input() treeList: DxTreeListComponent;
  @Output() cancel = new EventEmitter();

  productCount: number = 0;
  genVariantTexts: boolean = true;

  prompt: AiPrompt;
  field: string;


  constructor(public modelService: ModelService, public invoiceService: InvoiceService, public teachingSetService: TeachingSetService, public translate: TranslateService) {
    this.createJob = this.createJob.bind(this);
    this.back = this.back.bind(this);
  }

  ngOnInit(): void {
  }

  buildParam(): MassGenerateKITextsParameter {
    const selectedData: TreeItem[] = this.treeList.instance.getSelectedRowsData();

    const cat = selectedData.filter(t => t.type == "cat");
    if (cat.length > 0)
      return new MassGenerateKITextsParameter(
        cat[0].id.toString(),
        cat.length > 0,
        null,
        null,
        this.genVariantTexts,
        this.prompt.id,
        this.field
      );
    const grp = selectedData.filter(t => t.type == "grp");
    const pro = selectedData.filter(t => t.type == "pro");

    return new MassGenerateKITextsParameter(
      this.modelService.catalogService.catalog.id,
      cat.length > 0,
      grp.map(x => x.id.toString()),
      pro.map(x => x.id.toString()),
      this.genVariantTexts,
      this.prompt.id,
      this.field
    );
  }

  createJob() {
    this.invoiceService.startMassGenerateOpenAITextsJob(this.modelService.loginService.currentCustomer.id, this.buildParam()).subscribe(() => {
      this.modelService.systemService.notifyInfo(this.translate.instant("Der Job wurde gestartet"), 2);
    });
    this.cancel.emit();
  }

  back() {
    this.cancel.emit();
  }
}
